import type { CartesianPose } from '@sb/geometry';
import { ros2TooltipToTarget, rotvecToQuaternion } from '@sb/geometry';

/**
 * Convert a recording frame `{ translation, rotation }` (rotation as a
 * rotvec, as written by echo-bot's pose recorder) into a UI-frame
 * CartesianPose.
 *
 * The recorder publishes flange orientation in the ACB/ROS2 (Z-out)
 * convention, so each frame's orientation must be re-expressed into the
 * UI/runtime (X-out) frame via `ros2TooltipToTarget` (right-multiply by
 * `ROTATE_XY_90⁻¹`). Position passes through unchanged.
 *
 * Shared between the runtime (RunDemonstration.Step) and the planned-path
 * visualizer (useVisualizeRunDemonstrationPlan) so they always agree.
 */
export function rotvecFrameToPose(frame: {
  translation: { x: number; y: number; z: number };
  rotation: { x: number; y: number; z: number };
}): CartesianPose {
  return ros2TooltipToTarget({
    x: frame.translation.x,
    y: frame.translation.y,
    z: frame.translation.z,
    ...rotvecToQuaternion(frame.rotation),
  });
}
